jQuery(function($)
{
  //Adding new function to window
  window.customDropdown = newCustomDropdown;

  //Running new function with onChange callback
  $(document).ready(function(){
      window.customDropdown('.custom-select.reflections', onDropdownChange);
  });

  //Setting cookie with a callback function
  function onDropdownChange(){
    $exploreID = $('.custom-select select').val();
    document.cookie = 'explore=' + $exploreID + ';path=/;';
  }

  //Setting up new function for custom dropdowns
  function newCustomDropdown(containerClass, onChangeFunction) {
    var $customSelect  = $(containerClass);
    var $hiddenSelect  = $customSelect.find('select');
    var $hiddenOptions = $hiddenSelect.find('option');
    var $label;
    var $selectItems;

    $customSelect.append('<div class="select-selected" id="' + $customSelect.attr('dropdown') + '"></div>');
    $customSelect.append('<div class="select-items select-hide"></div>');

    $label         = $customSelect.find('.select-selected');
    $selectItems   = $customSelect.find('.select-items');

    //For each hidden option, create a new dropdown option
    $hiddenOptions.each(function (i, elem){

      var $option = $(elem);

      // Append our User Prompt Option as our initial label
      if ($option.attr('selected')) {
        $label.text($option.text());
        $selectItems.append('<div id="custom_option_' + i + '">' + $option.html() + '</div>');
      }
      // else if($option.attr('disabled')) { } //Use this to skip the intial option
      else{
        $selectItems.append('<div id="custom_option_' + i + '">' + $option.html() + '</div>');
      }
    });

    //OnClick function for new dropdown options (selects the clicked option)
    $selectItems.find('div').on('click touch', function(ev) {
      var $item = $(ev.currentTarget);

      $label.text($item.text()); //Set custom label
      $hiddenSelect.find('option[selected]').removeAttr('selected'); //Remove 'selected' attr from hidden <select>
      $hiddenSelect.find('#' + $item.attr('id').replace('custom_','selected_')).attr('selected',' '); //Add 'selected' attr to hidden <select> option
      onChangeFunction(); //Update cookie

      console.log(ev);


      if($('.custom-select-list').length > 0){

        $('.custom-select-list').addClass('ajax-loading');
        $.ajax({
           type:     'POST',
           url:      '/wp/wp-admin/admin-ajax.php?action=load_video_grid&cat_slug=' + $hiddenSelect.find('option[selected]').val() + '&style=list',
           dataType: "json",
           headers: {
             'Content-Type': 'application/json'
           },
           success: function(data){
             var $videoGrid = $('.custom-select-list');
             var $newVideos;
             if (data && data.body) {
               $newVideos = data.body;
               $videoGrid.html($newVideos);
             }
           },
           error: function (e) {
             console.log('Error while fetching more messages', e);
             // $('.custom-select-list').html('An error was encountered');
           },
           complete: function(response){
             // console.log("http://$_SERVER[HTTP_HOST]$_SERVER[REQUEST_URI]" + ' ', response);
             $('.custom-select-list').removeClass('ajax-loading');
           }
        });
      }
      if($('.custom-select-grid').length > 0){

        $('.custom-select-grid').addClass('ajax-loading');
        $.ajax({
           type:     'POST',
           url:      '/wp/wp-admin/admin-ajax.php?action=load_video_grid&cat_slug=' + $hiddenSelect.find('option[selected]').val() + '&style=grid',
           dataType: "json",
           headers: {
             'Content-Type': 'application/json'
           },
           success: function(data){
             var $videoGrid = $('.custom-select-grid');
             var $newVideos;
             if (data && data.body) {
               $newVideos = data.body;
               $videoGrid.html($newVideos);
             }
           },
           error: function (e) {
             console.log('Error while fetching more messages', e);
             // $('.custom-select-grid').html('An error was encountered');
           },
           complete: function(response){
             // console.log("http://$_SERVER[HTTP_HOST]$_SERVER[REQUEST_URI]" + ' ', response);
             $('.custom-select-grid').removeClass('ajax-loading');
           }
        });
      }

    });

    //OnClick function for the arrow (displays new custom dropdown)
    $(document).on('click touch', function (e) {

      var $target = $(e.target);

      var isContainer = $target.hasClass(containerClass);
      var hasChild    = $customSelect.has($target)[0];

      if (!isContainer && !hasChild) {
        $selectItems.addClass('select-hide');
        $label.removeClass('select-arrow-active');
      }
      else {
        if ($selectItems.hasClass('select-hide')) {
          $selectItems.removeClass('select-hide');
          $label.addClass('select-arrow-active');
        }
        else {
          $selectItems.addClass('select-hide');
          $label.removeClass('select-arrow-active');
        }
      }
    });
  }
});

jQuery(function($) {

  initSiteSearch();

  function initSiteSearch() {
    $('.yrm_search__icon, .search-button').on('click', function() {
      var $content = $('.modal-search-wrap .yrm_search__form');

      setTimeout(function () {
        $.magnificPopup.open({
          removalDelay: 0,
          closeBtnInside: true,
          showCloseBtn: true,
          overflowY: 'scroll',
          mainClass: 'search-modal-container',
          items: {
            src: $content
          },
          type: 'inline'
        });
      }, 100);

      return false;
    });
  }

});

(function($) {

	$(function() {
		$('#tabs li a:not(:first)').addClass('inactive');
		$('#tabs li:not(:first)').addClass('no-border');
		$('.panel').hide();
		$('.panel:first').show();

		$('#tabs li a').click(function(){
			var tab = $(this).attr('id');
			var panel = document.getElementById(tab);

			if ($(this).hasClass('inactive')) {
				$('#tabs li a').addClass('inactive');
				$('#tabs li').addClass('no-border');
				$(this).parent().removeClass('no-border');
				$(this).removeClass('inactive');

				$('.panel').hide();
        $('.panels-container').scrollTop(0);
				$('#p-'+ tab).fadeIn('slow');
			}
		});
	});

})(jQuery);
